<template>
  <head>
    <meta charset="utf-8" />
    <title>Clearance Certificates</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Header -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="page-header-card">
                <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
                  <div class="d-flex align-items-center">
                    <div class="page-icon bg-primary-subtle me-3">
                      <i class="mdi mdi-file-certificate text-primary"></i>
                    </div>
                    <div>
                      <h4 class="mb-1 fw-bold">Clearance Certificates</h4>
                      <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0">
                          <li class="breadcrumb-item"><a href="javascript: void(0);" class="text-muted">Dashboards</a></li>
                          <li class="breadcrumb-item"><a href="javascript: void(0);" class="text-muted">Land & Plots</a></li>
                          <li class="breadcrumb-item active text-primary">Certificates</li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                  <div class="d-flex gap-2">
                    <button @click="getSummary" class="btn btn-outline-primary" :disabled="loading">
                      <i class="mdi mdi-refresh" :class="{'mdi-spin': loading}"></i>
                    </button>
                    <router-link :to="{name: 'clearance-dashboard'}" class="btn btn-primary">
                      <i class="mdi mdi-view-dashboard me-1"></i> Dashboard
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Toolbar -->
          <ToolBarClearance/>

          <!-- Stats Cards - Clickable Filters -->
          <div class="row g-3 mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card stat-card border-0 shadow-sm h-100" @click="setFilter('')" :class="{'active-filter': filterStatus === ''}">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stat-icon bg-primary-subtle rounded-circle me-3">
                      <i class="mdi mdi-file-document-multiple text-primary"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Total</p>
                      <h4 class="mb-0 fw-bold">{{ totalCertificates }}</h4>
                    </div>
                    <i v-if="filterStatus === ''" class="mdi mdi-check-circle text-primary"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card stat-card border-0 shadow-sm h-100" @click="setFilter('PENDING')" :class="{'active-filter': filterStatus === 'PENDING'}">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stat-icon bg-warning-subtle rounded-circle me-3">
                      <i class="mdi mdi-clock-outline text-warning"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Pending</p>
                      <h4 class="mb-0 fw-bold text-warning">{{ summary.pending || 0 }}</h4>
                    </div>
                    <span class="badge bg-warning text-dark" v-if="summary.pending > 0">{{ pendingPercentage }}%</span>
                  </div>
                  <div class="progress mt-3" style="height: 4px;">
                    <div class="progress-bar bg-warning" :style="{width: pendingPercentage + '%'}"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card stat-card border-0 shadow-sm h-100" @click="setFilter('APPROVED')" :class="{'active-filter': filterStatus === 'APPROVED'}">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stat-icon bg-success-subtle rounded-circle me-3">
                      <i class="mdi mdi-check-circle text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Approved</p>
                      <h4 class="mb-0 fw-bold text-success">{{ summary.approved || 0 }}</h4>
                    </div>
                    <span class="badge bg-success" v-if="summary.approved > 0">{{ approvedPercentage }}%</span>
                  </div>
                  <div class="progress mt-3" style="height: 4px;">
                    <div class="progress-bar bg-success" :style="{width: approvedPercentage + '%'}"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card stat-card border-0 shadow-sm h-100" @click="setFilter('DECLINED')" :class="{'active-filter': filterStatus === 'DECLINED'}">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stat-icon bg-danger-subtle rounded-circle me-3">
                      <i class="mdi mdi-close-circle text-danger"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Declined</p>
                      <h4 class="mb-0 fw-bold text-danger">{{ summary.declined || 0 }}</h4>
                    </div>
                    <span class="badge bg-danger" v-if="summary.declined > 0">{{ declinedPercentage }}%</span>
                  </div>
                  <div class="progress mt-3" style="height: 4px;">
                    <div class="progress-bar bg-danger" :style="{width: declinedPercentage + '%'}"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content Card -->
          <div class="row">
            <div class="col-12">
              <div class="card border-0 shadow-sm">
                <!-- Header -->
                <div class="card-header bg-white py-3">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div class="d-flex align-items-center">
                      <div class="icon-box rounded me-3" :class="getStatusHeaderClass">
                        <i :class="getStatusHeaderIcon"></i>
                      </div>
                      <div>
                        <h5 class="mb-0 fw-bold">{{ getStatusTitle }} Certificates</h5>
                        <small class="text-muted">Manage certificate requests</small>
                      </div>
                    </div>
                    <div class="d-flex flex-wrap gap-2 align-items-center">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="keyword" type="text" class="form-control" placeholder="Search..." style="min-width: 180px;">
                          <i class="mdi mdi-magnify search-icon"></i>
                        </div>
                      </div>
                      <select v-model="filterStatus" class="form-select" style="width: 130px;">
                        <option value="">All Status</option>
                        <option value="PENDING">Pending</option>
                        <option value="APPROVED">Approved</option>
                        <option value="DECLINED">Declined</option>
                      </select>
                      <select v-model="subCounty" class="form-select" style="width: 150px;">
                        <option value="">All Sub-Counties</option>
                        <option v-for="(item, index) in subCounties" :key="index" :value="item">{{ item.subCountyName }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Date Filter -->
                <div class="card-header bg-light py-2 border-bottom">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
                    <div class="d-flex flex-wrap align-items-center gap-2">
                      <span class="text-muted small fw-semibold">Date:</span>
                      <input v-model="dateFrom" type="date" class="form-control form-control-sm" style="width: 140px;">
                      <span class="text-muted">to</span>
                      <input v-model="dateTo" type="date" class="form-control form-control-sm" style="width: 140px;">
                      <button @click="getClearanceCertificates" class="btn btn-sm btn-primary"><i class="mdi mdi-filter-outline"></i></button>
                      <button @click="clearFilters" class="btn btn-sm btn-outline-secondary"><i class="mdi mdi-filter-remove-outline"></i></button>
                    </div>
                    <button @click="downloadReport" class="btn btn-sm btn-success" :disabled="certificates.length === 0">
                      <i class="mdi mdi-download me-1"></i> Export
                    </button>
                  </div>
                </div>

                <!-- Table -->
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="bg-light">
                      <tr>
                        <th class="border-0 ps-4">#</th>
                        <th class="border-0">Bill Details</th>
                        <th class="border-0">Property</th>
                        <th class="border-0">Owner</th>
                        <th class="border-0">Location</th>
                        <th class="border-0 text-end">Amount</th>
                        <th class="border-0 text-center">Status</th>
                        <th class="border-0">Created</th>
                        <th class="border-0 text-center pe-4">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in certificates" :key="index" class="certificate-row">
                        <td class="ps-4 text-muted">{{ ((currentPage - 1) * pageSize) + index + 1 }}</td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="bill-icon rounded me-3" :class="getStatusIconClass(item.approvalStatus)">
                              <i :class="getStatusIcon(item.approvalStatus)"></i>
                            </div>
                            <div>
                              <h6 class="mb-0 fw-semibold">{{ item.billNo }}</h6>
                              <span class="badge bg-light text-dark small">{{ item.feeDescription }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="fw-medium">{{ item.customer || '-' }}</div>
                          <small class="text-muted text-truncate d-block" style="max-width: 120px;">{{ item.description }}</small>
                        </td>
                        <td>
                          <div class="fw-medium">{{ item.names }}</div>
                          <small class="text-muted">ID: {{ item.idNo }}</small>
                        </td>
                        <td>
                          <div class="fw-medium">{{ item.subCountyName }}</div>
                          <small class="text-muted">{{ item.wardName }}</small>
                        </td>
                        <td class="text-end">
                          <div class="fw-bold">KES {{ numberFormat(item.billTotal) }}</div>
                          <small class="text-success">Paid: {{ numberFormat(item.receiptAmount) }}</small>
                        </td>
                        <td class="text-center">
                          <span class="badge rounded-pill" :class="getStatusBadgeClass(item.approvalStatus)">{{ item.approvalStatus }}</span>
                          <div v-if="item.approvedBy" class="small text-muted mt-1">{{ getApproverName(item.approvedBy) }}</div>
                        </td>
                        <td>
                          <div class="small">{{ formatDate(item.dateCreated) }}</div>
                          <small class="text-muted">{{ item.createdBy }}</small>
                        </td>
                        <td class="text-center pe-4">
                          <div class="btn-group">
                            <button @click="viewCertificate(item)" class="btn btn-sm btn-soft-info" data-bs-toggle="modal" data-bs-target="#viewCertificateModal" title="View">
                              <i class="mdi mdi-eye-outline"></i>
                            </button>

                            <button v-if="item.approvalStatus === 'APPROVED' && getRight('CLEARANCE PRINT')" @click="printCertificate(item)" class="btn btn-sm btn-soft-primary" title="Print">
                              <i class="mdi mdi-printer-outline"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <div class="text-center py-5" v-if="loading">
                      <div class="spinner-border text-primary mb-3"></div>
                      <h6 class="text-muted">Loading...</h6>
                    </div>

                    <div class="text-center py-5" v-if="certificates.length === 0 && !loading">
                      <div class="empty-icon mb-3"><i class="mdi mdi-file-search-outline text-muted"></i></div>
                      <h5 class="text-muted fw-bold">No Certificates Found</h5>
                    </div>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white py-3" v-if="certificates.length > 0">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div class="d-flex align-items-center">
                      <span class="text-muted me-2 small">Show</span>
                      <select v-model="pageSize" class="form-select form-select-sm" style="width: 80px;">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="text-muted small me-3">{{ ((currentPage - 1) * pageSize) + 1 }}-{{ Math.min(currentPage * pageSize, totalCount) }} of {{ totalCount }}</span>
                      <nav>
                        <ul class="pagination pagination-sm mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" @click="prevPage"><i class="mdi mdi-chevron-left"></i></a>
                          </li>
                          <li class="page-item" v-for="page in visiblePages" :key="page" :class="{ active: currentPage === page }">
                            <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" @click="nextPage"><i class="mdi mdi-chevron-right"></i></a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- View Modal -->
      <div class="modal fade" id="viewCertificateModal" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content border-0">
            <div class="modal-header" :class="getModalHeaderClass">
              <h5 class="modal-title text-white"><i class="mdi mdi-file-certificate me-2"></i>Certificate Details</h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body" v-if="selectedCertificate">
              <div class="status-badge d-flex align-items-center p-3 rounded mb-4" :class="getStatusBgClass(selectedCertificate.approvalStatus)">
                <div class="status-icon me-3"><i :class="getStatusModalIcon(selectedCertificate.approvalStatus)"></i></div>
                <div class="flex-grow-1">
                  <h6 class="mb-0 fw-bold" :class="getStatusTextClass(selectedCertificate.approvalStatus)">{{ selectedCertificate.approvalStatus }}</h6>
                  <small class="text-muted" v-if="selectedCertificate.approvedBy">By {{ selectedCertificate.approvedBy }}</small>
                  <small class="text-muted" v-else>Awaiting review</small>
                </div>
                <span class="badge" :class="getStatusBadgeClass(selectedCertificate.approvalStatus)">{{ selectedCertificate.approvalStatus }}</span>
              </div>

              <div v-if="selectedCertificate.declineReason" class="reason-card p-3 rounded border border-warning bg-warning-subtle mb-4">
                <h6 class="fw-bold text-warning mb-2"><i class="mdi mdi-alert-outline me-2"></i>Decline Reason</h6>
                <p class="mb-0">{{ selectedCertificate.declineReason }}</p>
              </div>

              <div class="row g-3">
                <div class="col-md-6">
                  <div class="info-card p-3 rounded bg-light h-100">
                    <h6 class="text-primary fw-bold mb-3"><i class="mdi mdi-receipt me-2"></i>Bill Info</h6>
                    <p class="mb-2"><span class="text-muted small d-block">Bill No</span><strong>{{ selectedCertificate.billNo }}</strong></p>
                    <p class="mb-2"><span class="text-muted small d-block">Fee</span><strong>{{ selectedCertificate.feeDescription }}</strong></p>
                    <p class="mb-2"><span class="text-muted small d-block">Total</span><strong class="text-primary">KES {{ numberFormat(selectedCertificate.billTotal) }}</strong></p>
                    <p class="mb-0"><span class="text-muted small d-block">Paid</span><strong class="text-success">KES {{ numberFormat(selectedCertificate.receiptAmount) }}</strong></p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-card p-3 rounded bg-light h-100">
                    <h6 class="text-primary fw-bold mb-3"><i class="mdi mdi-account me-2"></i>Customer Info</h6>
                    <p class="mb-2"><span class="text-muted small d-block">Customer</span><strong>{{ selectedCertificate.customer }}</strong></p>
                    <p class="mb-2"><span class="text-muted small d-block">Owner</span><strong>{{ selectedCertificate.names }}</strong></p>
                    <p class="mb-2"><span class="text-muted small d-block">ID No</span><strong>{{ selectedCertificate.idNo }}</strong></p>
                    <p class="mb-0"><span class="text-muted small d-block">Phone</span><strong>{{ selectedCertificate.phoneNumber }}</strong></p>
                  </div>
                </div>
                <div class="col-12">
                  <div class="info-card p-3 rounded bg-light">
                    <h6 class="text-primary fw-bold mb-3"><i class="mdi mdi-map-marker me-2"></i>Location</h6>
                    <div class="row">
                      <div class="col-md-4"><span class="text-muted small d-block">Sub-County</span><strong>{{ selectedCertificate.subCountyName }}</strong></div>
                      <div class="col-md-4"><span class="text-muted small d-block">Ward</span><strong>{{ selectedCertificate.wardName }}</strong></div>
                      <div class="col-md-4"><span class="text-muted small d-block">Zone</span><strong>{{ selectedCertificate.zone }}</strong></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
              <button v-if="selectedCertificate && selectedCertificate.approvalStatus === 'PENDING' && getRight('CLEARANCE APPROVE')" @click="switchToApprove" class="btn btn-success" data-bs-dismiss="modal"><i class="mdi mdi-check me-1"></i>Approve</button>
              <button v-if="selectedCertificate && selectedCertificate.approvalStatus === 'PENDING' && getRight('CLEARANCE DECLINE')" @click="switchToDecline" class="btn btn-danger" data-bs-dismiss="modal"><i class="mdi mdi-close me-1"></i>Decline</button>
              <button v-if="selectedCertificate && selectedCertificate.approvalStatus === 'APPROVED' && getRight('CLEARANCE PRINT')" @click="printCertificate(selectedCertificate)" class="btn btn-primary"><i class="mdi mdi-printer me-1"></i>Print</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Approve Modal -->
      <div class="modal fade" id="approveModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0">
            <div class="modal-header bg-success text-white">
              <h5 class="modal-title text-white"><i class="mdi mdi-check-circle me-2"></i>Approve</h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body" v-if="selectedCertificate">
              <div class="text-center mb-4">
                <div class="approve-icon mb-3"><i class="mdi mdi-check-circle text-success"></i></div>
              </div>
              <div class="summary-box p-3 rounded bg-light mb-3">
                <div class="d-flex justify-content-between mb-2"><span class="text-muted">Bill No</span><strong>{{ selectedCertificate.billNo }}</strong></div>
                <div class="d-flex justify-content-between mb-2"><span class="text-muted">Customer</span><strong>{{ selectedCertificate.names }}</strong></div>
                <div class="d-flex justify-content-between"><span class="text-muted">Amount</span><strong class="text-success">KES {{ numberFormat(selectedCertificate.billTotal) }}</strong></div>
              </div>
              <div class="mb-3">
                <label class="form-label fw-semibold">Notes (Optional)</label>
                <textarea v-model="approvalNotes" class="form-control" rows="2" placeholder="Notes..."></textarea>
              </div>
            </div>
            <div class="modal-footer border-0">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
              <button @click="approveCertificate" class="btn btn-success" :disabled="processing">
                <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>...</span>
                <span v-else><i class="mdi mdi-check me-1"></i>Approve</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Decline Modal -->
      <div class="modal fade" id="declineModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0">
            <div class="modal-header bg-danger text-white">
              <h5 class="modal-title text-white"><i class="mdi mdi-close-circle me-2"></i>Decline</h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body" v-if="selectedCertificate">
              <div class="text-center mb-4">
                <div class="decline-icon mb-3"><i class="mdi mdi-close-circle text-danger"></i></div>
              </div>
              <div class="summary-box p-3 rounded bg-light mb-3">
                <div class="d-flex justify-content-between mb-2"><span class="text-muted">Bill No</span><strong>{{ selectedCertificate.billNo }}</strong></div>
                <div class="d-flex justify-content-between"><span class="text-muted">Customer</span><strong>{{ selectedCertificate.names }}</strong></div>
              </div>
              <div class="mb-3">
                <label class="form-label fw-semibold">Reason <span class="text-danger">*</span></label>
                <textarea v-model="declineReason" class="form-control" rows="3" placeholder="Reason..." required></textarea>
              </div>
            </div>
            <div class="modal-footer border-0">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
              <button @click="declineCertificate" class="btn btn-danger" :disabled="processing || !declineReason.trim()">
                <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>...</span>
                <span v-else><i class="mdi mdi-close me-1"></i>Decline</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer"><div class="container-fluid"><div class="row"><div class="col-sm-6"></div></div></div></footer>
    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToolBarClearance from "@/components/landrate/ToolBarClearance.vue";
import moment from "moment/moment";
import { biller, execute, getRight, landRate } from "@/api";

export default {
  name: "ClearanceCertificates",
  components: { NavigationBar, ToolBarClearance },
  data() {
    return {
      loading: false, processing: false, keyword: '', filterStatus: '', dateFrom: '', dateTo: '',
      currentPage: 1, totalPages: 0, totalCount: 0, pageSize: 10,
      certificates: [], selectedCertificate: null, approvalNotes: '', declineReason: '',
      summary: { pending: 0, approved: 0, declined: 0 }, subCounties: [], subCounty: ''
    }
  },
  computed: {
    totalCertificates() { return (this.summary.pending || 0) + (this.summary.approved || 0) + (this.summary.declined || 0); },
    pendingPercentage() { return this.totalCertificates > 0 ? Math.round((this.summary.pending / this.totalCertificates) * 100) : 0; },
    approvedPercentage() { return this.totalCertificates > 0 ? Math.round((this.summary.approved / this.totalCertificates) * 100) : 0; },
    declinedPercentage() { return this.totalCertificates > 0 ? Math.round((this.summary.declined / this.totalCertificates) * 100) : 0; },
    getStatusTitle() { return this.filterStatus ? this.filterStatus.charAt(0) + this.filterStatus.slice(1).toLowerCase() : 'All'; },
    getStatusHeaderClass() {
      if (this.filterStatus === 'PENDING') return 'bg-warning text-dark';
      if (this.filterStatus === 'APPROVED') return 'bg-success text-white';
      if (this.filterStatus === 'DECLINED') return 'bg-danger text-white';
      return 'bg-primary text-white';
    },
    getStatusHeaderIcon() {
      if (this.filterStatus === 'PENDING') return 'mdi mdi-clock-outline';
      if (this.filterStatus === 'APPROVED') return 'mdi mdi-check-circle';
      if (this.filterStatus === 'DECLINED') return 'mdi mdi-close-circle';
      return 'mdi mdi-file-certificate';
    },
    getModalHeaderClass() {
      if (!this.selectedCertificate) return 'bg-info text-white';
      const s = this.selectedCertificate.approvalStatus;
      if (s === 'PENDING') return 'bg-warning';
      if (s === 'APPROVED') return 'bg-success text-white';
      if (s === 'DECLINED') return 'bg-danger text-white';
      return 'bg-info text-white';
    },
    visiblePages() {
      const p = []; let s = Math.max(1, this.currentPage - 2); let e = Math.min(this.totalPages, s + 4);
      if (e - s < 4) s = Math.max(1, e - 4);
      for (let i = s; i <= e; i++) p.push(i);
      return p;
    }
  },
  watch: {
    pageSize() { this.currentPage = 1; this.getClearanceCertificates(); },
    keyword() { this.currentPage = 1; this.getClearanceCertificates(); },
    filterStatus() { this.currentPage = 1; this.getClearanceCertificates(); },
    subCounty() { this.currentPage = 1; this.getClearanceCertificates(); }
  },
  mounted() { this.getClearanceCertificates(); this.getSummary(); this.getSubCounties(); },
  methods: {
    getRight(type) { return getRight(type); },
    numberFormat(num) { return new Intl.NumberFormat("en-GB").format(num || 0); },
    formatDate(date) { return date ? moment(date).format('DD MMM YYYY HH:mm') : ''; },
    getApproverName(by) { if (!by) return '-'; const m = by.match(/^([^(]+)/); return m ? m[1].trim() : by; },
    setFilter(s) { this.filterStatus = s; },
    clearFilters() { this.filterStatus = ''; this.subCounty = ''; this.dateFrom = ''; this.dateTo = ''; this.keyword = ''; this.getClearanceCertificates(); },
    getStatusIconClass(s) { if (s === 'PENDING') return 'bg-warning-subtle text-warning'; if (s === 'APPROVED') return 'bg-success-subtle text-success'; if (s === 'DECLINED') return 'bg-danger-subtle text-danger'; return 'bg-secondary-subtle text-secondary'; },
    getStatusIcon(s) { if (s === 'PENDING') return 'mdi mdi-clock-outline'; if (s === 'APPROVED') return 'mdi mdi-check-circle'; if (s === 'DECLINED') return 'mdi mdi-close-circle'; return 'mdi mdi-file-document'; },
    getStatusBadgeClass(s) { if (s === 'PENDING') return 'bg-warning text-dark'; if (s === 'APPROVED') return 'bg-success'; if (s === 'DECLINED') return 'bg-danger'; return 'bg-secondary'; },
    getStatusBgClass(s) { if (s === 'PENDING') return 'bg-warning-subtle'; if (s === 'APPROVED') return 'bg-success-subtle'; if (s === 'DECLINED') return 'bg-danger-subtle'; return 'bg-secondary-subtle'; },
    getStatusTextClass(s) { if (s === 'PENDING') return 'text-warning'; if (s === 'APPROVED') return 'text-success'; if (s === 'DECLINED') return 'text-danger'; return 'text-secondary'; },
    getStatusModalIcon(s) { if (s === 'PENDING') return 'mdi mdi-clock-outline text-warning font-size-32'; if (s === 'APPROVED') return 'mdi mdi-check-circle text-success font-size-32'; if (s === 'DECLINED') return 'mdi mdi-close-circle text-danger font-size-32'; return 'mdi mdi-file-document text-secondary font-size-32'; },
    prevPage() { if (this.currentPage > 1) { this.currentPage--; this.getClearanceCertificates(); } },
    nextPage() { if (this.currentPage < this.totalPages) { this.currentPage++; this.getClearanceCertificates(); } },
    goToPage(p) { if (p !== this.currentPage) { this.currentPage = p; this.getClearanceCertificates(); } },
    getSubCounties() { const d = new FormData(); d.append("function", "getSubCounty"); execute(d, biller).then((r) => { if (r.data.success) this.subCounties = r.data.data.subCounties; }).catch(console.error); },
    getClearanceCertificates() {
      this.loading = true; this.certificates = [];
      const d = new FormData();
      d.append("function", "getClearanceCertificates"); d.append("page", this.currentPage); d.append("rows_per_page", this.pageSize);
      d.append("search", this.keyword); d.append("approvalStatus", this.filterStatus);
      d.append("subCountyName", this.subCounty ? this.subCounty.subCountyName : '');
      d.append("dateFrom", this.dateFrom); d.append("dateTo", this.dateTo);
      execute(d, landRate).then((r) => { this.loading = false; if (r.data.success) { this.certificates = r.data.data.certificates || []; this.totalCount = r.data.data.count?.count || 0; this.totalPages = Math.ceil(this.totalCount / this.pageSize); } }).catch((e) => { this.loading = false; console.error(e); });
    },
    getSummary() { const d = new FormData(); d.append("function", "getClearanceCertificateSummary"); execute(d, landRate).then((r) => { if (r.data.success) this.summary = r.data.data.summary; }).catch(console.error); },
    viewCertificate(i) { this.selectedCertificate = i; },
    selectForApproval(i) { this.selectedCertificate = i; this.approvalNotes = ''; },
    selectForDecline(i) { this.selectedCertificate = i; this.declineReason = ''; },
    switchToApprove() { setTimeout(() => { new bootstrap.Modal(document.getElementById('approveModal')).show(); }, 300); },
    switchToDecline() { setTimeout(() => { new bootstrap.Modal(document.getElementById('declineModal')).show(); }, 300); },
    approveCertificate() {
      if (!this.selectedCertificate) return; this.processing = true;
      const d = new FormData(); d.append("function", "approveClearanceCertificate"); d.append("id", this.selectedCertificate.id);
      d.append("billNo", this.selectedCertificate.billNo); d.append("notes", this.approvalNotes);
      d.append("sessionNames", sessionStorage.getItem("sessionNames")); d.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(d, landRate).then((r) => { this.processing = false; if (r.data.success) { alert("Approved!"); this.closeModal('approveModal'); this.getClearanceCertificates(); this.getSummary(); } else alert("Error: " + r.data.message); }).catch((e) => { this.processing = false; alert("Error: " + e.message); });
    },
    declineCertificate() {
      if (!this.selectedCertificate || !this.declineReason.trim()) return alert("Provide reason."); this.processing = true;
      const d = new FormData(); d.append("function", "declineClearanceCertificate"); d.append("id", this.selectedCertificate.id);
      d.append("billNo", this.selectedCertificate.billNo); d.append("declineReason", this.declineReason);
      d.append("sessionNames", sessionStorage.getItem("sessionNames")); d.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(d, landRate).then((r) => { this.processing = false; if (r.data.success) { alert("Declined!"); this.closeModal('declineModal'); this.getClearanceCertificates(); this.getSummary(); } else alert("Error: " + r.data.message); }).catch((e) => { this.processing = false; alert("Error: " + e.message); });
    },
    printCertificate(i) { localStorage['params'] = JSON.stringify({ certificateId: i.id, billNo: i.billNo }); const r = this.$router.resolve({ name: 'clearance-certificate-print' }); window.open(r.href, '_blank'); },
    closeModal(id) { const m = document.getElementById(id); if (m) { const i = bootstrap.Modal.getInstance(m); if (i) i.hide(); } },
    downloadReport() {
      if (this.certificates.length === 0) return;
      const h = ['#', 'Bill No', 'Fee', 'Customer', 'Names', 'ID', 'Phone', 'Sub County', 'Ward', 'Total', 'Paid', 'Balance', 'Status', 'Approved By', 'Date'];
      const c = this.certificates.map((i, x) => [x + 1, i.billNo, i.feeDescription, i.customer, i.names, i.idNo, i.phoneNumber, i.subCountyName, i.wardName, i.billTotal, i.receiptAmount, i.billBalance, i.approvalStatus, i.approvedBy || '', moment(i.dateCreated).format('YYYY-MM-DD HH:mm')]);
      let csv = h.join(',') + '\n'; c.forEach(r => { csv += r.map(f => `"${String(f || '').replace(/"/g, '""')}"`).join(',') + '\n'; });
      const b = new Blob([csv], { type: 'text/csv;charset=utf-8;' }); const l = document.createElement('a'); l.href = URL.createObjectURL(b); l.download = `Clearance_Certificates_${moment().format('YYYY-MM-DD')}.csv`; l.click();
    }
  }
}
</script>

<style scoped>
.page-header-card { background: linear-gradient(135deg, #e8eaf6 0%, #fff 100%); padding: 1.25rem; border-radius: 12px; border: 1px solid #556ee633; }
.page-icon { width: 56px; height: 56px; display: flex; align-items: center; justify-content: center; border-radius: 12px; font-size: 28px; }
.stat-card { border-radius: 12px; transition: all 0.3s ease; cursor: pointer; }
.stat-card:hover { transform: translateY(-3px); box-shadow: 0 8px 25px rgba(0,0,0,0.1) !important; }
.stat-card.active-filter { border: 2px solid #556ee6 !important; }
.stat-icon { width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; font-size: 24px; }
.icon-box { width: 44px; height: 44px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
.bill-icon { width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; font-size: 18px; }
.search-box { position: relative; }
.search-box .search-icon { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); color: #adb5bd; }
.certificate-row:hover { background-color: rgba(85, 110, 230, 0.05); }
.btn-soft-info { color: #50a5f1; background-color: rgba(80, 165, 241, 0.1); border: none; }
.btn-soft-info:hover { color: #fff; background-color: #50a5f1; }
.btn-soft-success { color: #34c38f; background-color: rgba(52, 195, 143, 0.1); border: none; }
.btn-soft-success:hover { color: #fff; background-color: #34c38f; }
.btn-soft-danger { color: #f46a6a; background-color: rgba(244, 106, 106, 0.1); border: none; }
.btn-soft-danger:hover { color: #fff; background-color: #f46a6a; }
.btn-soft-primary { color: #556ee6; background-color: rgba(85, 110, 230, 0.1); border: none; }
.btn-soft-primary:hover { color: #fff; background-color: #556ee6; }
.bg-primary-subtle { background-color: rgba(85, 110, 230, 0.15) !important; }
.bg-success-subtle { background-color: rgba(52, 195, 143, 0.15) !important; }
.bg-warning-subtle { background-color: rgba(241, 180, 76, 0.15) !important; }
.bg-danger-subtle { background-color: rgba(244, 106, 106, 0.15) !important; }
.bg-secondary-subtle { background-color: rgba(116, 120, 141, 0.15) !important; }
.empty-icon { width: 100px; height: 100px; display: flex; align-items: center; justify-content: center; margin: 0 auto; background: rgba(108, 117, 125, 0.1); border-radius: 50%; }
.empty-icon i { font-size: 50px; }
.status-icon { width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; }
.status-icon i { font-size: 32px; }
.approve-icon, .decline-icon { width: 80px; height: 80px; margin: 0 auto; display: flex; align-items: center; justify-content: center; border-radius: 50%; }
.approve-icon { background: rgba(52, 195, 143, 0.1); }
.decline-icon { background: rgba(244, 106, 106, 0.1); }
.approve-icon i, .decline-icon i { font-size: 48px; }
.info-card { border: 1px solid #e9ecef; }
.reason-card { border-left: 4px solid #f1b44c; }
.summary-box { border: 1px solid #e9ecef; }
.page-link { cursor: pointer; border-radius: 6px !important; margin: 0 2px; }
.page-item.active .page-link { background-color: #556ee6; border-color: #556ee6; }
.font-size-32 { font-size: 32px; }
</style>